import { cn, RadioGroup, RadioGroupItem, RadioGroupItemProps, RadioGroupProps } from '@landler/component-library';
import React from 'react';
import { UseFormReturn } from 'react-hook-form';

import { FormControl, FormField, FormItem, FormLabel } from '@/components/Form';

import { useControlsContext } from './Form';

type FormRadioGroupProps = RadioGroupProps & {
  name: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  controlsform?: UseFormReturn<any>;
};

export const FormRadioGroup = ({ name, className, onValueChange, controlsform, ...delegated }: FormRadioGroupProps) => {
  // TODO: MVP-CW refactor to use only one context
  const formWidgetControlsform = useControlsContext();
  const controls = controlsform ?? formWidgetControlsform;

  return (
    <FormField
      name={name}
      control={controls.control}
      render={({ field: { onChange, ...field } }) => (
        <FormItem>
          <FormControl>
            <RadioGroup
              className={cn('flex flex-col gap-2', className)}
              {...field}
              onValueChange={(...args) => {
                onValueChange?.(...args);
                onChange(...args);
              }}
              data-testid={`radiogroup-${field.name}`}
              {...delegated}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
};

export const FormRadioItem = ({
  value,
  label,
  removeFormItems,
  formName,
  styles,
  ...delegated
}: RadioGroupItemProps & {
  label: React.ReactNode;
  removeFormItems?: string[];
  formName?: string;
  styles?: Record<string, string>;
}) => {
  const { setValue } = useControlsContext();

  const handleOnClick = () => {
    if (removeFormItems) {
      removeFormItems.forEach((item) => {
        setValue(item, null);
      });
    }

    if (formName) {
      setValue(formName, value);
    }
  };

  return (
    <FormItem className={cn('flex items-center gap-2 w-fit', styles?.root)}>
      <FormControl>
        <RadioGroupItem value={value} onClick={handleOnClick} className={styles?.radioItem} {...delegated} />
      </FormControl>
      <FormLabel className={cn('typography-body2 text-text-primary', styles?.label)}>{label}</FormLabel>
    </FormItem>
  );
};
